import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'whatwg-fetch';
import { createRoot } from 'react-dom/client';
import React, { Suspense } from 'react';
import { UIProvider } from '@folksam/ui-next/providers';
import App from './App';
import ConfigurationProvider from './providers/Configuration';
import { readConfiguration } from './services/common.service';
import { initI18n } from './i18n';
import OptionsProvider from './providers/Options';
import { Global, css } from '@emotion/react';

const configuration = readConfiguration('folksam-react-fun-product-banner');
const rootEl = document.querySelector('[data-folksam-app-id="folksam-react-fun-product-banner"]');
const root = createRoot(rootEl);
// Setup translations
initI18n(configuration.translations, configuration.commonData, configuration.configuration);

root.render(
    <UIProvider>
        <ConfigurationProvider configuration={configuration}>
            {/* Options provider is used in DynamicMultiSerivce banners */}
            <OptionsProvider>
                <Suspense fallback={() => <div>Loading</div>}>
                    <Global
                        styles={css`
                            [id^='select-list-'] ul {
                                font-size: inherit;
                            }
                        `}
                    />
                    <App />
                </Suspense>
            </OptionsProvider>
        </ConfigurationProvider>
    </UIProvider>
);
